// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon___S3vp9"};